import React, { useRef } from "react";
import useRipple from "./UseRipple.tsx";
import Utils from "../Utils";

export default function CustomButton({ Width, Label, OnClick }) {
  const ref = useRef(null);
  const ripples = useRipple(ref);

  return (
    <Utils.InputButton ref={ref} width={Width} onClick={OnClick}>
      {ripples}
      {Label}
    </Utils.InputButton>
  );
}

export function CustomLableButton({ Img , Dis }) {
  return (
    <Utils.LableButton width={Dis}>
      <Utils.Icon src={Img}/>
    </Utils.LableButton>
  );
}
